<script>
    import store from '@/store';

    export default {
        name: 'Tracking',
        render() {
            return null;
        },
        data() {
            return {
                trackingScript: null,
                code: `console.log('test');`,
                pardot: {
                    piAId: '',
                    piCId: ''
                }
            };
        },
        computed: {
            websiteSettingsStyles: () => {
                if (store.state.websiteSettings !== null) {
                    return store.state.websiteSettings.styles;
                }
            }
        },
        mounted() {
        },
        watch: {
            '$store.state.websiteSettings': function () {
                if (store.state.websiteSettings !== null) {
                    this.updateData();
                }
            }
        },
        methods: {
            updateData() {
                this.pardot.piAId = this.websiteSettingsStyles.piAld ? this.websiteSettingsStyles.piAld : '';
                this.pardot.piCId = this.websiteSettingsStyles.piCld ? this.websiteSettingsStyles.piCld : '';

                if (this.pardot.piAId !== '' && this.pardot.piCId !== '' && this.pardot.piAId !== '0' && this.pardot.piCId !== '0') {
                    if (store.state.keenInfos.hidden) {
                        console.log(`Hidden Mode. No pardot recording. piAId = '${this.pardot.piAId}' piCId = '${this.pardot.piCId}'`);
                        return;
                    }

                    this.trackingScript = document.createElement('script');
                    this.trackingScript.classList.add('trackingScript');
                    this.trackingScript.textContent = `piAId = '${this.pardot.piAId}';
piCId = '${this.pardot.piCId}';
piHostname = 'pi.pardot.com';
var s = document.createElement('script'); s.type = 'text/javascript';
s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);`;
                    document.body.appendChild(this.trackingScript);
                }
                /*
                if (this.pardot.piAId !== '' && this.pardot.piCId !== '' && this.pardot.piAId !== '0' && this.pardot.piCId !== '0') {
                    //this.trackingScript.textContent = `piAId = '${this.pardot.piAId}';console.log(piAId);`;
                    this.trackingScript.textContent = `piAId = '${this.pardot.piAId}';
piCId = '${this.pardot.piCId}';
piHostname = 'pi.pardot.com';
(function() {
    function async_load(){
        var s = document.createElement('script'); s.type = 'text/javascript';
        s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
        var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
    }
    if(window.attachEvent) { window.attachEvent('onload', async_load); }
    else { window.addEventListener('load', async_load, false); }
})();`;
                }
                */
            }
        }
    };
</script>
